import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { Cours } from './cours.model';

@Injectable()
export class CoursService {

    private resourceUrl = 'api/cours';

    private static convertResponse(res: any): any {
        res._body = res.json();
        return res;
    }

    constructor(private http: Http) { }

    create(cours: Cours): Observable<Cours> {
        let copy: Cours = Object.assign({}, cours);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(cours: Cours[]): Observable<Cours[]> {
        let copy: Cours[] = [];
        cours.forEach(c => {
            copy.push(c);
        });
        if (copy != null && copy.length > 0) {
            return this.http.put(this.resourceUrl, copy).map((res: Response) => {
                return res.json();
            });
        }
        return null;
    }

    find(id: number): Observable<Cours> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return  res.json();
        });
    }

    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.candidatureFormationId) {
            params.set('candidatureFormationId', req.candidatureFormationId);
        }
        return this.http.get(this.resourceUrl, { search: params })
            .map((res: any) => CoursService.convertResponse(res))
        ;
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    isCoursEmpty(listeCours: Cours[]): boolean {
        let filtered =  listeCours.filter(
            cours => !(cours.code !== undefined && cours.code.length > 0 && cours.libelle !== undefined && cours.libelle.length > 0) ) ;
        return filtered.length > 0 ;
    }

    isCoursExistant(listeCours: Cours[]): boolean {
        let filtered =  listeCours.filter(cours => !(cours.libelle !== undefined && cours.libelle.length > 0)) ;
        return filtered.length > 0 ;
    }

    isCoursDuplique(listeCours: Cours[]): boolean {
        return this.checkDuplicateInObject('code', listeCours)  ;
    }

    checkDuplicateInObject(propertyName, inputArray) {
        let seenDuplicate = false,
            testObject = {};

        inputArray.map(function(item) {
            let itemPropertyName = item[propertyName];
            if (itemPropertyName in testObject) {
                testObject[itemPropertyName].duplicate = true;
                item.duplicate = true;
                seenDuplicate = true;
            } else {
                testObject[itemPropertyName] = item;
                delete item.duplicate;
            }
        });

        return seenDuplicate;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/candidature/cours.service.ts